// import { ws_req } from '@/ws/wss-request'
import { ref, onMounted, onUnmounted } from 'vue'

/**
 * 实时数据轮询
 * @param {object} options 配置参数
 * @param {Function} options.updateFunction 更新函数
 * @param {number} [options.interval] 更新间隔时间
 * @param {object} [options.initData] 初始数据
 * @param {boolean} [options.immediate] 是否立即更新
 * @param {Function} [options.onUpdate] 更新回调
 */
function useRealData(options) {

  const defaultOptions = {
    interval: 5000,
    initData: {},
    immediate: true
  }

  Object.assign(defaultOptions, options)

  // ws_req
  const realData = ref(defaultOptions.initData)
  let timer

  const update = (recursive = false) => {
    if (options.updateFunction) {
      
      const promise = options.updateFunction()
      if (promise instanceof Promise) {
        promise.then(res => {
          realData.value = res || defaultOptions.initData
          options.onUpdate?.(realData.value)
        })
        promise.catch(err => {
          console.warn(err)
        })
      } else {
        throw new Error('updateFunction must return a Promise')
      }

      if (recursive) {
        // 更新
        timer = setTimeout(() => {
          update(recursive)
        }, defaultOptions.interval);
      }
    }
  }


  // 开始更新
  const start = () => {
    clearTimeout(timer)
    timer = null
    update(true)
  }

  // 停止更新
  const stop = () => {
    clearTimeout(timer)
    timer = null
  }

  // 更新一次，不递归
  const updateOnce = () => {
    update(false)
  }


  if (defaultOptions.immediate) {    
    start()
  }

  onUnmounted(() => {
    clearTimeout(timer)
  })

  return {
    realData,
    start,
    stop,
    updateOnce,
  }

}



export { useRealData }
